export default {
    1: {
        id: 1,
        text: 'Pendiente',
        type: 'warning'
    },
    2: {
        id: 2,
        text: 'Activo',
        type: 'success'
    },
    3: {
        id: 3,
        text: 'Activo',
        type: 'success'
    },
    4: {
        id: 4,
        text: 'Anulado',
        type: 'danger'
    },
    5: {
        id: 5,
        text: 'Rechazado',
        type: 'warning'
    },
    6: {
        id: 6,
        text: 'Liquidado',
        type: 'success'
    },
    7: {
        id: 7,
        text: 'Observado',
        type: 'success'
    },
};
